import tenantMenuList from '@tenantMenuList';
import { TENANT_KEY } from '../../../utility/env';
import { menuList } from './menuList';

const sideBarMenuList = Object.freeze({ key: TENANT_KEY, menuList, ...tenantMenuList });

export default sideBarMenuList;
